import { createAction, props } from '@ngrx/store';
import {
  IGenericResponse,
  IRole,
} from '../../models/role.model';

export const listSystemRoles = createAction('[Role] List System Roles');

export const listSystemRolesSuccess = createAction(
  '[Role] List System Roles Success',
  props<IGenericResponse<IRole[]>>()
);

export const listSystemRolesFailure = createAction(
  '[Role] List System Roles Failure',
  props<{ error: string }>()
);
export const getSingleRole = createAction(
  '[Role] Get Single Role',
  props<{ id: string }>()
);

export const getSingleRoleSuccess = createAction(
  '[Role] Get Single Role Success',
  props<IGenericResponse<IRole>>()
);

export const getSingleRoleFailure = createAction(
  '[Role] Get Single Role Failure',
  props<{ error: string }>()
);

export const RoleActions = {
  listSystemRoles,
  listSystemRolesSuccess,
  listSystemRolesFailure,
  getSingleRole,
  getSingleRoleSuccess,
  getSingleRoleFailure,
};
